import { getConfig } from '../config/configuration';
import type { HpDispatchFunction } from './actionTypes';
import { fetchResolver } from './fetchResolver';
import { ErrorMap } from 'interfaces/errorTypes';
import { FullPolicyData } from 'interfaces/customerDataTypes';
import { AUDIT_TYPE } from 'interfaces/auditTypes';
import { sendAuditEvent } from 'utils';
import { CustomerPolicyDetailsSuccessPayload } from './getCustomerPolicyAction';

interface ToggleDocumentPrintPreferenceProps {
  selectedPolicy: FullPolicyData;
  printPolicyDocs: boolean;
  username: string;
  isAgent: boolean;
}

export function toggleDocumentPrintPreferenceAction({
  selectedPolicy,
  printPolicyDocs,
  username,
  isAgent
}: ToggleDocumentPrintPreferenceProps) {
  return (dispatch: HpDispatchFunction<ErrorMap | CustomerPolicyDetailsSuccessPayload>): Promise<void> | undefined => {
    dispatch({ type: 'TOGGLE_PRINT_DOCUMENTS_LOADING' });
    const { policyDetailsId, historyId, policyNumber } = selectedPolicy;

    const data = {
      policyDetailsId,
      historyId,
      printPolicyDocs,
      ...(isAgent && { agentUsername: username })
    };

    const { websiteEndpoint } = getConfig();
    const url = `${websiteEndpoint}/api/customer/policy/toggle-print-documents`;

    return fetchResolver<any>({
      options: { url, data, method: 'POST', description: `Toggle document printing preferences` },
      dispatch,
      successAction: (response) => {
        const auditEventType = printPolicyDocs
          ? AUDIT_TYPE.TOGGLE_PRINT_DOCUMENTS_ON_SUCCESS
          : AUDIT_TYPE.TOGGLE_PRINT_DOCUMENTS_OFF_SUCCESS;
        sendAuditEvent({ activityId: auditEventType, policyDetailsId, historyId, policyNumber });
        dispatch({
          type: 'TOGGLE_PRINT_DOCUMENTS_SUCCESS',
          payload: {
            policyDetail: response,
            policyDetailsId,
            historyId
          }
        });
      },
      failedAction: (err) => {
        const auditEventType = printPolicyDocs
          ? AUDIT_TYPE.TOGGLE_PRINT_DOCUMENTS_ON_FAILURE
          : AUDIT_TYPE.TOGGLE_PRINT_DOCUMENTS_OFF_FAILURE;
        sendAuditEvent({ activityId: auditEventType, policyDetailsId, historyId, policyNumber });
        dispatch({ type: 'TOGGLE_PRINT_DOCUMENTS_ERROR', payload: err.message });
      }
    });
  };
}
